import { render, staticRenderFns } from "./downloads.vue?vue&type=template&id=209f1f37"
import script from "./downloads.vue?vue&type=script&lang=ts"
export * from "./downloads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports